import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	data: [],
	finalPromotion: null,
	error: false,
	loading: false
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			case types.FETCH_PROMOTIONS_LOADING:
				draft.data = [];
				draft.loading = false;
				draft.error = false;
				return;

			case types.FETCH_PROMOTIONS_SUCCESS:
				draft.data = action.payload;
				draft.loading = false;
				return;

			case types.FETCH_PROMOTIONS_ERROR:
				draft.loading = false;
				draft.error = true;
				return;

			case types.SET_FINAL_PROMOTION:
				draft.finalPromotion = action.payload;
				return;

			case types.CLEAR_FINAL_PROMOTION:
				draft.finalPromotion = null;
				return;

			default:
				return state;
		}
	});
